import { render } from "./EnPizza.vue?vue&type=template&id=76167aa7&scoped=true"
import script from "./EnPizza.vue?vue&type=script&lang=js"
export * from "./EnPizza.vue?vue&type=script&lang=js"

import "./EnPizza.vue?vue&type=style&index=0&id=76167aa7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76167aa7"]])

export default __exports__